import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiEndpoint } from '../../constants';
import prepareQuery from '../../helpers/prepareQuery';
import { RequestError } from '../../types';
import { Payload, RequestResponse } from './types';

export const check3ds = createAsyncThunk<RequestResponse, Payload, { rejectValue: RequestError }>(
  'virtualCard/operations/check3ds',
  async ({ query = {}, threeDSMethodData, processId }, { rejectWithValue }) => {
    try {
      const params = prepareQuery(query);

      const {
        body: { error, result },
      } = await superagent
        .post(ApiEndpoint.OperationCheckThreeDs)
        .query(params)
        .send({ threeDSMethodData, processId });

      if (error) {
        throw error;
      }

      return result;
    } catch (error: any) {
      return rejectWithValue(error.response.body as RequestError);
    }
  }
);
